(function () {
  const STORAGE_KEY = 'cd_recently_viewed';

  function formatMoney(cents) {
    return 'Rs. ' + (cents / 100).toFixed(2);
  }

function getValidItems() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const items = JSON.parse(raw);
    const now = Date.now();
    const valid = Array.isArray(items) ? items.filter(i => i.expiry > now) : [];

    // Deduplicate by product id — same product sirf ek baar
    const seen = new Set();
    return valid.filter(i => {
      const id = i.product && i.product.id;
      if (!id || seen.has(id)) return false;
      seen.add(id);
      return true;
    });
  } catch (e) {
    return [];
  }
}

  function hasRealVariants(product) {
    return !(
      product.options &&
      product.options.length === 1 &&
      product.options[0].values.length === 1 &&
      product.options[0].values[0] === 'Default Title'
    );
  }

  function buildVariantSelect(product) {
    const real = hasRealVariants(product);

    if (!real) {
      // No real variants — hidden select, matches your first card structure
      return `<div style="height: 40px;display: block;">
        <select style="display:none" class="cd_variant_options"></select>
      </div>`;
    }

    const options = product.variants.map(v => {
      const img = (v.featured_image && v.featured_image.src)
        ? v.featured_image.src.replace(/^\/\//, 'https://')
        : (product.featured_image || '').replace(/^\/\//, 'https://');
      const available = v.available ? '1' : '0';
      const price = formatMoney(v.price);
      return `<option value="${v.id} " variant_available="${available}" price="${price}" img="${img}">${v.title}</option>`;
    });

    return `<div style="height: 40px;display: block;">
      <select class="cd_recently_viewed_products_variant_options">
        ${options.join(',')}
      </select>
    </div>`;
  }

  function getDefaultVariantId(product) {
    return product.variants && product.variants[0] ? product.variants[0].id : '';
  }

  function buildCard(item) {
    const p = item.product;
    const imgSrc = (p.featured_image || (p.images && p.images[0]) || '').replace(/^\/\//, 'https://');
    const price = formatMoney(p.price_min);
    const variantId = getDefaultVariantId(p);

    return `<div class="cd_recently_viewed_products_grid__item">
  <div class="cd_recently_viewed_products_card">
    <div class="cd_recently_viewed_products_card__content">

      <span class="cd_recently_viewed_products_card__img">
        <a class="cd_recently_viewed_products_card_link" href="${p.url}" target="_blank">
          <img style="width:100%" src="${imgSrc}" alt="${p.title}">
        </a>
      </span>

      <a class="cd_recently_viewed_products_card__header cd_tooltiptext_parent_div" href="${p.url}">
        <p class="cd_order_product_title">${p.title}</p>
        <span class="cd_tooltiptext">${p.title}</span>
      </a>

      <p class="cd_recently_viewed_products_card__text">
        <span>${price}</span>
      </p>

      ${buildVariantSelect(p)}

      <div class="cd_recently_viewed_products_product_quantity">
        <input class="cd_recently_viewed_products_product_quantity_btn_minus" type="button" value="-">
        <input class="cd_recently_viewed_products_product_quantity_input"
          onkeypress="return (event.key!='0' && event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
          pattern="[0-9.]+" type="text" value="1">
        <input class="cd_recently_viewed_products_product_quantity_btn_plus" type="button" value="+">
      </div>

      <button class="cd_recently_viewed_products_card__btn"
        style="cursor:pointer;opacity:1"
        variant_quantity="1"
        variant="${variantId}">
        Add to cart
      </button>

    </div>
  </div>
</div>`;
  }

  function bindEvents(grid) {
    // Quantity +/-
    grid.querySelectorAll('.cd_recently_viewed_products_card__content').forEach(card => {
      const minus = card.querySelector('.cd_recently_viewed_products_product_quantity_btn_minus');
      const plus  = card.querySelector('.cd_recently_viewed_products_product_quantity_btn_plus');
      const input = card.querySelector('.cd_recently_viewed_products_product_quantity_input');
      const btn   = card.querySelector('.cd_recently_viewed_products_card__btn');
      const sel   = card.querySelector('.cd_recently_viewed_products_variant_options');

      minus.addEventListener('click', function () {
        let val = parseInt(input.value) || 1;
        if (val > 1) {
          input.value = val - 1;
          btn.setAttribute('variant_quantity', val - 1);
        }
      });

      plus.addEventListener('click', function () {
        let val = parseInt(input.value) || 1;
        input.value = val + 1;
        btn.setAttribute('variant_quantity', val + 1);
      });

      input.addEventListener('change', function () {
        let val = parseInt(this.value) || 1;
        if (val < 1) val = 1;
        this.value = val;
        btn.setAttribute('variant_quantity', val);
      });

      // Variant select — update button variant + price display
      if (sel) {
        sel.addEventListener('change', function () {
          const selected = this.options[this.selectedIndex];
          const variantId = selected.value.trim();
          const price     = selected.getAttribute('price');
          const imgSrc    = selected.getAttribute('img');

          btn.setAttribute('variant', variantId);

          const priceEl = card.querySelector('.cd_recently_viewed_products_card__text span');
          if (priceEl && price) priceEl.textContent = price;

          const imgEl = card.querySelector('.cd_recently_viewed_products_card__img img');
          if (imgEl && imgSrc) imgEl.src = imgSrc.replace(/^\/\//, 'https://');
        });
      }

      // Add to cart
      btn.addEventListener('click', function () {
        const variantId = this.getAttribute('variant');
        const qty       = parseInt(this.getAttribute('variant_quantity')) || 1;

        if (!variantId) return;

        this.textContent = 'Adding...';
        this.style.opacity = '0.7';
        this.style.cursor = 'not-allowed';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
        })
          .then(r => r.json())
          .then(() => {
            window.location.href = '/cart';
            // document.dispatchEvent(new CustomEvent('cd:cart:updated'));
          })
          .catch(() => {
            this.textContent = 'Error — try again';
            this.style.opacity = '1';
            this.style.cursor = 'pointer';
          });
      });
    });
  }

  function render() {
    const dashboard = document.getElementById('customer_dashboard');
    if (!dashboard) return;

    const rvSection = dashboard.querySelector(
      '.cd_main-content #cd_recently-viewed.cd_main-section.cd_main-section-2'
    );
    if (!rvSection) return;

    const grid = rvSection.querySelector(
      '.cd_address-section-main .cd_address-main-section .cd_recently_viewed_products_grid'
    );
    if (!grid) return;

    const items = getValidItems();

    if (!items.length) {
      grid.innerHTML = '<p style="font-size:14px;color:#888;">No recently viewed products.</p>';
      return;
    }

    grid.innerHTML = items.map(item => buildCard(item)).join('');
    bindEvents(grid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();